import * as http from 'gs-browser-http';
import { cfg } from '../config';

// const url = "http://147.102.110.48:15082/api/rest/v1/theme/b2b/product/vineyard";
const url = cfg.apiUrlBase + "/api/rest/v1/theme/b2b/product/vineyard";

export interface Product {
    name: string
    label?: string
    short_label?: string
    id: string
    price: ((quantity: number) => number)
    dataset?: { theme: string, id: string, name: string, verifyText?: string }[]
    fixed?: boolean
    selected?: boolean
    max_area: number
    modules?: String[]      // submodule id
    _price_div?: HTMLDivElement
    _checkbox_input?: HTMLInputElement
}

export interface ProductModule {
    name: string
    label?: string
    short_label?: string
    id: string
    price: string
    dataset?: { theme: string, id: string, name: string, verifyText?: string }[]
    fixed?: boolean
    selected?: boolean
    max_area: number,
    modules?: String[]      // submodule id
}

export interface ProductSet {
    product_id: string[], label: string, price: ((price: number) => number)
}

class ProviderProduct {

    private products: Product[] | undefined;
    private product_sets: ProductSet[] = [];
    private _max_area: number = 5000;
    private _label_price: string = "";

    constructor() {
        // http.GET(url).then(r => {
        //     let content: { max_area: number, modules: ProductModule[] } = JSON.parse(r.data);
        //     this._max_area = content.max_area;
        //     let modules: Product[] = content.modules.map(m => {
        //         var tmp_price_function: ((quantity: number) => number) = (quantity: number) => { return 0; };
        //         eval(`tmp_price_function = function(q){ return ${m.price};};`);
        //         let out = { id: m.id, name: m.name, fixed: m.fixed, price: tmp_price_function, dataset: m.dataset, max_area: m.max_area };
        //         return out;
        //     })
        //     this.products.push(...modules);
        // });

        // this.products.push(
        //     {
        //         name: "Topographical suitablility",
        //         id: "",
        //         price: (quantity: number) => {
        //             return quantity * 5;
        //         },
        //         fixed: true
        //     },
        //     {
        //         name: "3D site model & cold air flow",
        //         id: "",
        //         price: (quantity: number) => {
        //             return quantity * 5;
        //         }
        //     },
        //     {
        //         name: "Land use and soil",
        //         id: "",
        //         price: (quantity: number) => {
        //             return quantity * 5;
        //         }
        //     },
        //     {
        //         name: "Protected status",
        //         id: "",
        //         price: (quantity: number) => {
        //             return quantity * 5;
        //         }
        //     },
        //     {
        //         name: "Watershed",
        //         id: "",
        //         price: (quantity: number) => {
        //             return quantity * 5;
        //         }
        //     },
        //     {
        //         name: "Transport networks",
        //         id: "",
        //         price: (quantity: number) => {
        //             return quantity * 5;
        //         }
        //     },
        //     {
        //         name: "Terrestrial suitability score",
        //         id: "",
        //         price: (quantity: number) => {
        //             return quantity * 5;
        //         }
        //     }

        // )
    }

    private getProducts() {
        return http.GET(url).then(r => {
            let content: {
                max_area: number, label_price?: string,
                modules: ProductModule[],
                module_sets?: { modules_id: string[], label: string, price: string }[]
            } = JSON.parse(r.data);
            this._max_area = content.max_area;
            if (content.label_price !== undefined) { this._label_price = content.label_price };
            let modules: Product[] = content.modules.map(m => {
                var tmp_price_function: ((quantity: number) => number) = (quantity: number) => { return 0; };
                eval(`tmp_price_function = function(q){ return ${m.price};};`);
                let out = { id: m.id, short_label: m.short_label, label: m.label, name: m.name, fixed: m.fixed, price: tmp_price_function, dataset: m.dataset, max_area: m.max_area, modules: m.modules };
                return out;
            })
            this.products = [];
            this.products.push(...modules);

            this.product_sets = [];
            if (content.module_sets !== undefined) {
                content.module_sets.forEach(ps => {

                    var tmp_price_function: ((price: number) => number) = (price: number) => { return 0; };
                    eval(`tmp_price_function = function(q){ return ${ps.price};};`);

                    this.product_sets.push({
                        label: ps.label,
                        product_id: [...ps.modules_id],
                        price: tmp_price_function
                    });
                })
            }
        });
    }

    async get(): Promise<Product[]> {
        if (this.products === undefined) {
            await this.getProducts();
        }
        return Promise.resolve(this.products || []);
    }

    get max_area(): number {
        return this._max_area
        // console.log(this._max_area);
        // return Promise.resolve(this._max_area);
    }

    get label_price(): string {
        return this._label_price;
        // console.log(this._max_area);
        // return Promise.resolve(this._max_area);
    }

    public procuct_set(id_list: string[]): ProductSet | undefined {
        let out: ProductSet | undefined;

        this.product_sets.forEach(ps => {
            if (ps.product_id.every(id => { /*console.log(id, id_list.indexOf(id));*/ return id_list.indexOf(id) !== -1 })) {
                out = ps;
            }
        });
        return out;
    }
}

export let providerProduct = new ProviderProduct();